
// const servicesIcon
const Invoice = require("../assets/images/invoice.jpg");
const StkRec = require("../assets/images/stk-rec.PNG");
const Maps = require("../assets/images/maps.PNG");
const Maps2 = require("../assets/images/maps2.PNG");
const STK2 = require("../assets/images/stock2.PNG");
const featuresListing = {
  "Outlet Records": {icon:Maps, graph: "Hotelace can be customised to accomodate the number of outlets in a given property, with accuarate postings and stockings."},
  "Stock Report": {icon:Invoice, graph: "Hotelace accounts stock related operations: added stock, opening stock, units sold, stock transfer etc"},
  "Sales and Sales-summary": {icon:StkRec, graph: "Hotelace collates sales-summary after EOD, for the various outlets and consequently, the related stock-records, for each day,"},
  "Requisitions & Issuance": {icon:Maps2, graph: "Hotelace records requisitions and issuances from the store, to the designated outlets; thereby, providing controls and assessment of stocks, in the store."},
  "Requisitions & Issuances": {icon:STK2, graph: "Hotelace records requisitions and issuances from the store, to the designated outlets; thereby, providing controls and assessment of stocks, in the store."},

}

const OtherServices = () => {
    return(
      <section id="alt-services" className="alt-services section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row gy-4">
          {
            Object.keys(featuresListing).map(feat => (
              <div key={feat} className="col-lg-6" data-aos="zoom-in" data-aos-delay="200">
                <div className="service-item position-relative">
                  <div className="img">
                    <img style={{width:'auto', height: "37vh"}} src={((featuresListing as any)[feat]).icon} className="img-fluid" alt=""/>
                  </div>
                  {/* <div className="details"> */}
                    {/* <a href="service-details.html" className="stretched-link">
                      <h3>{feat}</h3>
                    </a> */}
                    {/* <p>{((featuresListing as any)[feat]).graph}</p> */}
                  {/* </div> */}
                </div>
              </div>
            ))
          }
{/* 
          <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="300">
            <div className="service-item position-relative">
              <div className="img">
                <img src="assets/img/services-2.jpg" className="img-fluid" alt=""/>
              </div>
              <div className="details">
                <a href="service-details.html" className="stretched-link">
                  <h3>Eosle Commodi</h3>
                </a>
                <p>Ut autem aut autem non a. Sint sint sit facilis nam iusto sint. Libero corrupti neque eum hic non ut nesciunt dolorem.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="400">
            <div className="service-item position-relative">
              <div className="img">
                <img src="assets/img/services-3.jpg" className="img-fluid" alt=""/>
              </div>
              <div className="details">
                <a href="service-details.html" className="stretched-link">
                  <h3>Ledo Markt</h3>
                </a>
                <p>Ut excepturi voluptatem nisi sed. Quidem fuga consequatur. Minus ea aut. Vel qui id voluptas adipisci eos earum corrupti.</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="500">
            <div className="service-item position-relative">
              <div className="img">
                <img src="assets/img/services-4.jpg" className="img-fluid" alt=""/>
              </div>
              <div className="details">
                <a href="service-details.html" className="stretched-link">
                  <h3>Asperiores Commodit</h3>
                </a>
                <p>Non et temporibus minus omnis sed dolor esse consequatur. Cupiditate sed error ea fuga sit provident adipisci neque.</p>
                <a href="service-details.html" className="stretched-link"></a>
              </div>
            </div>
          </div> */}

        </div>

      </div>

    </section>
    )
}


export default OtherServices